/**
 * Reservation form for out-of-stock variants
 * Vallenciano - Premium European Clothing
 */
(function () {
  let lastState = {};

  function getVariantsArray(sectionId) {
    const selector = document.querySelector('product-selector[data-section-id="' + sectionId + '"]');
    if (!selector) return [];

    const scripts = selector.querySelectorAll('script[type="application/json"]');
    for (const script of scripts) {
      if (!script.hasAttribute('data-selected-variant')) {
        try {
          const data = JSON.parse(script.textContent);
          if (Array.isArray(data)) return data;
        } catch (e) {}
      }
    }
    return [];
  }

  function getSelectedOptions(sectionId) {
    const selector = document.querySelector('product-selector[data-section-id="' + sectionId + '"]');
    if (!selector) return [];

    const options = [];
    selector.querySelectorAll('input[type="radio"]:checked, select').forEach(el => {
      options.push(el.value);
    });
    return options;
  }

  function findVariantByOptions(variants, selectedOptions) {
    return variants.find(variant => {
      const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
      return selectedOptions.every((opt, i) => variantOptions[i] === opt);
    });
  }

  // Called once after redirect with the success hash — swaps form for success message.
  function showSuccessState(panel) {
    const form = panel.querySelector('.product__notify-me-native-form');
    const successEl = panel.querySelector('.product__notify-me-success');
    const messageEl = panel.querySelector('.product__notify-me-message');
    if (form) form.style.display = 'none';
    if (successEl) successEl.removeAttribute('hidden');
    if (messageEl) messageEl.style.display = 'none';
    panel.dataset.submitted = 'true';
    panel.style.display = 'block';
  }

  // On page load, check if Shopify redirected back with our success hash.
  function checkSuccessHash() {
    const hash = window.location.hash;
    if (!hash.startsWith('#notify-me-')) return;
    const sectionId = hash.slice('#notify-me-'.length);
    const panel = document.getElementById('NotifyMe-' + sectionId);
    if (panel) {
      showSuccessState(panel);
      // Clean the hash so a later page-reload doesn't re-show success.
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function updatePanel(panel) {
    // Success state is permanent for this page load — nothing to change.
    if (panel.dataset.submitted === 'true') return;

    const sectionId = panel.dataset.sectionId;
    const variants = getVariantsArray(sectionId);
    const selectedOptions = getSelectedOptions(sectionId);
    const variant = findVariantByOptions(variants, selectedOptions);
    const actionsContainer = panel.closest('.product__actions');

    const stickyBar = document.querySelector('.editorial-product__sticky-bar[data-section-id="' + sectionId + '"]');
    const stickyBtn = stickyBar ? stickyBar.querySelector('.editorial-product__add-btn') : null;

    const isUnavailable = variant && variant.available === false;

    if (isUnavailable) {
      panel.style.display = 'block';
      panel.dataset.variantId = variant.id;
      panel.dataset.variantTitle = variant.title || '';
      if (actionsContainer) actionsContainer.classList.add('notify-me-active');

      // Keep the hidden body field current so the submitted email has full variant context.
      const bodyField = panel.querySelector('.js-notify-body');
      if (bodyField) {
        const productTitle = panel.dataset.productTitle || '';
        bodyField.value =
          'Cerere de Rezervare Vallenciano\n\n' +
          'Produs: ' + productTitle + '\n' +
          'Varianta: ' + (variant.title || '') + '\n' +
          'ID Varianta: ' + variant.id + '\n\n' +
          'Clientul doreste sa rezerve aceasta piesa si sa primeasca consultanta pentru marime.';
      }

      if (stickyBtn) {
        stickyBtn.textContent = stickyBtn.dataset.reserveText || 'RESERVE';
        stickyBtn.type = 'button';
        stickyBtn.removeAttribute('form');
        stickyBtn.dataset.reserveMode = 'true';
      }
    } else {
      panel.style.display = 'none';
      if (actionsContainer) actionsContainer.classList.remove('notify-me-active');

      if (stickyBtn) {
        stickyBtn.textContent = stickyBtn.dataset.addText || 'ADD TO CART';
        stickyBtn.type = 'submit';
        stickyBtn.setAttribute('form', 'product-form-' + sectionId);
        delete stickyBtn.dataset.reserveMode;
      }
    }
  }

  function checkAllPanels() {
    document.querySelectorAll('.product__notify-me').forEach(function (panel) {
      const sectionId = panel.dataset.sectionId;
      const selectedOptions = getSelectedOptions(sectionId);
      const stateKey = sectionId + '-' + selectedOptions.join('-');

      if (lastState[sectionId] !== stateKey) {
        lastState[sectionId] = stateKey;
        updatePanel(panel);
      }
    });
  }

  // Format phone: only + at start and digits, max 12 digits
  function formatPhone(value) {
    let digits = value.replace(/[^\d+]/g, '');
    let hasPlus = digits.startsWith('+');
    digits = digits.replace(/\D/g, '').slice(0, 12);
    return hasPlus ? '+' + digits : digits;
  }

  function init() {
    checkSuccessHash();

    document.addEventListener('input', function (e) {
      if (e.target.classList.contains('product__notify-me-phone')) {
        const formatted = formatPhone(e.target.value);
        if (e.target.value !== formatted) {
          e.target.value = formatted;
        }
      }
    });

    // Sticky bar reserve button → scroll to and focus the notify-me form
    document.addEventListener('click', function (e) {
      const stickyBtn = e.target.closest('.editorial-product__add-btn[data-reserve-mode="true"]');
      if (stickyBtn) {
        e.preventDefault();
        const stickyBar = stickyBtn.closest('.editorial-product__sticky-bar');
        const sectionId = stickyBar ? stickyBar.dataset.sectionId : null;
        const notifyPanel = sectionId ? document.getElementById('NotifyMe-' + sectionId) : null;
        if (notifyPanel) {
          notifyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const emailInput = notifyPanel.querySelector('.product__notify-me-email');
          if (emailInput) setTimeout(function () { emailInput.focus(); }, 500);
        }
      }
    });

    setInterval(checkAllPanels, 300);
    checkAllPanels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
